import React from "react";
import { Snackbar as MuiSnackbar, Alert } from "@mui/material"; // 이름 변경

const MySnackbar = ({ open, onClose, message, severity }) => {
  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={6000} // 6초 후 자동으로 닫힘
      onClose={onClose}
    >
      <Alert onClose={onClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </MuiSnackbar>
  );
};

export default MySnackbar;
